import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Modal, ModalBody} from 'reactstrap';
import UploadFile from '../includes/UploadFile';
import * as userActions from "../../actions/user";
import {withRouter} from 'react-router';
import * as uploadActions from "../../actions/upload";
import * as playlistActions from "../../actions/playlist";
import {IMGIX_PATH} from "../../constants";


class UserNewItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            user_type:'',
            user_name: '',
            user_email: '',
            user_no :'',
            permissionlist:'',
            usernameErrormsg : '',
            emailErrormsg : '',
            phnoErrormsg : '',
            modal: false,
            redirect: false,
            builderState : false,
            builderUrl : '',
            image_path: null
        };

        this.toggle = this.toggle.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.showBuilder = this.showBuilder.bind(this);
        this.hideBuilder = this.hideBuilder.bind(this);
        this.resetState  = this.resetState.bind(this);
        this.showUseraddModal = this.showUseraddModal.bind(this);
    }
    shouldComponentUpdate(nextProps, nextState){

        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.userData.showUserForm !== prevProps.userData.showUserForm) {
            this.toggle();
        }


        if(this.props.userData && !this.props.userData.newUser && this.props.userData.userIndex !== prevProps.userData.userIndex ){
            let index = this.props.userData.userIndex;
            console.log(index)
           // let userList = this.props.userData.userList ? this.props.userData.userList: '';
            let userList = this.props.userData.searchIndex === true ? this.props.userData.filteredData : this.props.userData.userList;
            let edituserData = userList[index] ? userList[index] : '';
            this.setState({'image_path' : IMGIX_PATH+'assets/slider/'+edituserData.uniqueId+'.jpg?q='+Math.random()+'&fit=crop&h=150&w=150&auto=enhance&dpr=3%203x',
                'user_name' : edituserData.name,
                'user_email' : edituserData.display_name,
                'user_no' : edituserData.phone,
                'user_id' : edituserData.uniqueId,
                'user_type':edituserData.user_type })
        }
        }

    toggle() {
        let edituserData =this.props.userData.userList ? this.props.userData.userList[this.props.userData.userIndex]: '';
        this.setState({
            modal: !this.state.modal,
            emailErrormsg: '',
        });
        this.props.uploadErrors({'error' : '', fileType : ''});

        if(this.props.userData.newUser === false) {
            this.setState({
                user_email: edituserData.display_name,
                user_name : edituserData.name,
                user_no : edituserData.phone,
                user_type:edituserData.user_type
            });
        }

        if(this.props.userData.newUser) {
            this.resetState();
        }

    }
    resetState(){
        this.setState({
            value: '',
            user_type:'select',
            user_name: '',
            user_email: '',
            user_no :'',
            permissionlist:'',
            usertypeErrormsg : '',
            usernameErrormsg : '',
            emailErrormsg : '',
            phnoErrormsg : '',
            image_path: null
        });
        this.props.uploadErrors({'error' : '', fileType : ''});
    }

    showUseraddModal(){
        this.props.newUser();
        this.props.showUserModal();

    }
    getUploadedFile(fileName) {
        console.log(fileName);
        this.setState({
            image_path: fileName
        });
        console.log(this.state.image_path+"========= thi.state.iamgepath");

        let filePathToBePurged = IMGIX_PATH+'assets/slider/'+this.state.user_id+'.jpg?fit=crop&h=150&w=150&auto=enhance&dpr=3%203x';
        //Request to purging
        this.props.getImagepurged({image_name : this.state.user_id, image_path : filePathToBePurged});
    }

    showBuilder(e) {
        e.preventDefault();
        this.setState({
            builderState : true
        });
        this.handleSubmit(e, this.state.builderState);
    }

    hideBuilder(e) {
        e.preventDefault();
        this.setState({
            builderState : false
        });
        this.handleSubmit(e, this.state.builderState);
    }

    handleInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });

        if(event.target.value !== '') {
            event.target.classList.remove('is-invalid');
        }
        if(this.state.user_type !== ''){
            this.setState({
                usertypeErrormsg: ''
            });
        }
        if(this.state.user_name !== ''){
            this.setState({
                usernameErrormsg: ''
            });
        }
        if(this.state.user_email !== '' && event.target.name === 'user_email'){

            var userEmailData =  {
                user_email: event.target.value,
                user_id: (!this.props.userData.newUser) ? this.props.userData.userList[this.props.userData.userIndex].uniqueId : ""
            };
            console.log(userEmailData)
            this.props.checkExistingUser(userEmailData);

            this.setState({
                emailErrormsg: ''
            });

        }

        if(this.state.user_no !== ''){
            this.setState({
                phnoErrormsg: ''
            });
        }
    }

    handleSubmit(e) {
        console.log(this.state);
        //e.preventDefault();
        let formInvalid = 0;

        //Dropdown validation

        if (this.state.user_type === "select"){
            formInvalid++;
            document.getElementsByName('user_type')[0].classList.add('is-invalid');
            this.setState({
                usertypeErrormsg: ' User Type is required'
            });
        }

        //Name validation

        if( this.state.user_name === '') {
            formInvalid++;
            document.getElementsByName('user_name')[0].classList.add('is-invalid');
            this.setState({
                usernameErrormsg: 'User Name is required'
            });
        }

        //* Email validation

        let email=/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

        if (this.state.user_email === ""){
            formInvalid++;
            document.getElementsByName('user_email')[0].classList.add('is-invalid');
            this.setState({
                emailErrormsg: 'User Email is required'
            });
        }
        else
        {
            if(!email.test(this.state.user_email))
            {

                formInvalid++;
                document.getElementsByName('user_email')[0].classList.add('is-invalid');
                this.setState({
                    emailErrormsg: 'Email is not valid'
                });

            }
            else{
               if(this.props.userData.userExists=== 'invalid') {
                   formInvalid++;
                   this.setState({
                       emailErrormsg: 'Email already existing'
                   });
               }
               else{

                   this.setState({validation: true})
               }

            }
        }




        //*Phone no validation

        if(this.state.user_no === "")
        {
            formInvalid++;
            document.getElementsByName('user_no')[0].classList.add('is-invalid');
            this.setState({
                phnoErrormsg: 'Phone Number is required'
            });
        }
        else
        {
            if(isNaN(this.state.user_no))
            {
                formInvalid++;
                document.getElementsByName('user_no')[0].classList.add('is-invalid');
                this.setState({
                    phnoErrormsg: 'Phone Number is not valid'
                });
            }
            else
            {
                if (this.state.user_no.length!==10)
                {
                    formInvalid++;
                    document.getElementsByName('user_no')[0].classList.add('is-invalid');
                    this.setState({
                        phnoErrormsg: 'Phone Number is not valid'
                    });
                }
                else{
                    this.setState({
                        phnoErrormsg: ''
                    });
                }

            }
        }

        if( formInvalid === 0) {

            let userid = (!this.props.userData.newUser) ? this.props.userData.userList[this.props.userData.userIndex].uniqueId : "";
            let image_path = this.props.userData.newUser ? this.state.image_path : '' ;

            var userData = {
                user_email: this.state.user_email,
                user_name: this.state.user_name,
                user_phone: this.state.user_no,
                user_image: image_path,
                user_id: userid
            };

            console.log(userData);
            let userCreated = this.props.createUser(userData);
            console.log(userCreated);

            //this.props.forceUpdateHandler();
            this.toggle();


        }

    }

    render() {console.log(this.props.userData.userExists)
        console.log( this.props.userData.newUser)
        console.log( this.props.userData.userIndex)

        let index = this.props.userData.userIndex;
        //let userList = this.props.userData.userList ? this.props.userData.userList: '';
        let userlist = this.props.userData.userList ? this.props.userData.userList : '';
        let filteredData = this.props.userData.filteredData ? this.props.userData.filteredData : '';
        let userList = this.props.userData.searchIndex ? filteredData : userlist;
        let edituserData = userList[index] ? userList[index] : '';

        return (
                <div className="float-button-block" data-toggle="tooltip" data-placement="top" title=""
                     data-original-title="New User" onClick={this.showUseraddModal}>
                    <button className="float-button icon-lib float-add" data-task="new-user"
                            data-target="#newuser"></button>


                <Modal isOpen={this.state.modal} toggle={this.toggle} centered={true} className="vig-mod modal-lg vig-modal user-md create-new-pop" id="vignetModal-user" tabindex="-1" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <ModalBody>
                        <div className="modal-content-wrapper">
                            <div className="modal-header">
                                <form id="company">
                                    <button type="button" className="modal-btn-close" data-dismiss="modal" aria-label="Close" onClick={this.toggle} >✕</button>
                                    <h4 className="modal-title icon-lib title-icon">{this.props.userData.newUser ? 'Add User' : 'Edit User'}</h4>
                                </form>
                            </div>
                            <div className="modal-adduser-content">
                                <div className="modal-adduser-content-left">
                                    <div className="tag-block title">
                                        <h5>USER TYPE</h5>
                                        <div className="drop-wrap .modal-adduser-detail">
                                            <div className="select-box select-bg">
                                                {this.props.userData.newUser === true &&
                                                <select id="maindesignation" name="user_type" onChange={this.handleInputChange} >
                                                    <option value="select">Select</option>
                                                    <option value="USR">Normal User</option>
                                                    <option value="SPU">Admin</option>
                                                </select>
                                                }
                                                {this.props.userData.newUser === false &&
                                                    <select id="maindesignation" name="user_type" onChange={this.handleInputChange} >
                                                        <option value={this.state.user_type}>{this.state.user_type === "USR"? "Normal User" : "Admin"}</option>
                                                        {this.state.user_type === "USR" &&
                                                        <option value="SPU">Admin</option>
                                                        }
                                                        {this.state.user_type !== "USR" &&
                                                        <option value="USR">Normal User</option>
                                                        }
                                                    </select>
                                                }

                                            </div>
                                           <p className="error-message">{this.state.usertypeErrormsg}</p>
                                        </div>
                                    </div>
                                    <div className="modal-adduser-detail">
                                        <p>NAME</p>
                                        <div className="input-select">
                                            <input type="user-name" name="user_name" defaultValue={this.state.user_name} placeholder="User Name" onChange={this.handleInputChange} valid={false} />
                                            <p className="error-message">{this.state.usernameErrormsg}</p>
                                        </div>
                                    </div>
                                    <div className="modal-adduser-detail">
                                        <p>EMAIL</p>
                                        <div className="input-select">
                                            <input type="email" name="user_email" defaultValue={this.state.user_email} placeholder="Enter your email address" onChange={this.handleInputChange} valid={false} />
                                            <p className="error-message">{this.state.emailErrormsg}</p>
                                        </div>
                                    </div>
                                    <div className="modal-adduser-detail">
                                        <p>PHONE</p>
                                        <div className="input-select">
                                            <input type="number" name="user_no" defaultValue={this.state.user_no} placeholder="Enter your phone number" onChange={this.handleInputChange} valid={false} />
                                            <p className="error-message">{this.state.phnoErrormsg}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-adduser-content-right">
                                    <div className="modal-adduser-detail">
                                        <div className="modal-adduser-img">
                                            <div className="image-up" id="image-upload-container">

                                                {this.state.image_path &&
                                                <img src={this.state.image_path} crossOrigin="anonymous" className="text-center" alt="user"/>
                                                }
                                                {this.state.image_path === null &&
                                                <img src="assets/images/placeholder.png" alt="default" />
                                                }

                                                <UploadFile getUploadedFile={ this.getUploadedFile.bind(this)} type="add" item_type='USER' fileType="image" unique_id = {(!this.props.userData.newUser && edituserData.uniqueId) ? edituserData.uniqueId : ''} />
                                                {this.props.uploadData.loader &&

                                                <div id="progress-bar-wrapper"></div>
                                                }

                                            </div>
                                        </div>
                                        {this.props.uploadData.errors === true &&
                                        <p className="error-message">{this.props.uploadData.errorMessage}</p>
                                        }
                                    </div>
                                </div>
                                <div className="modal-adduser-content-btn">
                                    <div className="modal-btn btn-cancel">
                                        <a href="javascript:void(0);" className="" onClick={this.toggle}>CANCEL</a>
                                    </div>
                                    <div  className="modal-btn btn-create">
                                        <a href="javascript:void(0);" className="" onClick = {(e) => this.handleSubmit(e)}>{this.props.userData.newUser? "CREATE" : "UPDATE" }</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
                </div>
        );
    }
}

UserNewItem.propTypes = {
    completed: PropTypes.number
}


function mapStateToProps(state) {
    return {
        uploadData : state.upload.uploadData,
        userData  :state.user.userListData
    };
}
export default  withRouter(connect(mapStateToProps, {
    createUser : userActions.createUser,
    uploadErrors: uploadActions.uploadErrors,
    checkExistingUser :userActions.checkExistingUser,
    showUserModal : userActions.showUserModal,
    newUser : userActions.newUser,
    getImagepurged : playlistActions.purgeImage,
    updateIndex : userActions.updateIndex
})(UserNewItem));



// WEBPACK FOOTER //
// ./src/components/user/UserNewItem.js